import { useMutation } from "@tanstack/react-query";
import { cardIssuanceMutationFn } from "../../../../../api";
import { useEffect } from "react";

export function useCardIssuanceMutationReaction(limitId: string | undefined, shouldTrigger: boolean) {
  const cardIssuanceMutation = useMutation({
    mutationFn: cardIssuanceMutationFn,
  });

  useEffect(() => {
    // eslint-disable-next-line
    if (shouldTrigger && limitId && cardIssuanceMutation.status === "idle" && !cardIssuanceMutation.isSuccess) {
      cardIssuanceMutation.mutate({ limitId });
    }
  }, [shouldTrigger, limitId, cardIssuanceMutation.status, cardIssuanceMutation.isSuccess]);

  return cardIssuanceMutation;
}
